export const es = {
  header: {
    status: "DISPONIBLE",
    name: "LUAN LIMA",
    title: "INGENIERO DE SOFTWARE // ESPECIALISTA WEBRTC, LIVEKIT Y NESTJS",
    timeLabel: "BRT (UTC-3):"
  },
  hero: {
    badge: "INGENIERO DE SOFTWARE",
    titleLine1: "INGENIERÍA DE SISTEMAS",
    titleHighlight: "ESCALABLES Y TIEMPO REAL",
    titleLine2: "Y APIS DE ALTO RENDIMIENTO.",
    description: "Ingeniero de Software con más de 12 años de experiencia. Especialista en NestJS, Node.js, WebRTC, LiveKit, defensor del ecosistema Bun & Elysia.js, construyendo soluciones empresariales de alta concurrencia.",
    btnLinkedin: "PERFIL DE LINKEDIN",
    btnGithub: "REPOSITORIOS DE GITHUB"
  },
  specSheet: {
    header: "// FICHA TÉCNICA",
    name: "LUAN LIMA",
    mainRoleLabel: "CARGO:",
    mainRoleVal: "Ingeniero de Software",
    experienceLabel: "EXPERIENCIA:",
    experienceVal: "12+ Años de Actuación",
    focusLabel: "ESPECIALIDAD:",
    focusVal: "NestJS, Node.js, WebRTC, LiveKit, Bun & Elysia",
    languagesLabel: "IDIOMAS:",
    languagesVal: "Portugués, Inglés",
    workModelLabel: "MODALIDAD:",
    workModelVal: "Remoto / Contrato / Consultoría",
    locationLabel: "UBICACIÓN:",
    locationVal: "Brasil (UTC-3)",
    summary: "Ingeniero de Software con más de 12 años de experiencia creando sistemas en tiempo real, APIs de ultra baja latencia y aplicaciones escalables en el ecosistema JavaScript/TypeScript."
  },
  marquee: {
    headline: "// LÍNEA CONTINUA DE STACKS (PASE EL MOUSE PARA PAUSAR / CLIC PARA SELECCIONAR)",
    badge: "FULLSTACK JS"
  },
  matrix: {
    badge: "// MATRIZ DE COMPETENCIAS",
    title: "Stack Tecnológico y de Ingeniería",
    categoryAll: "TODOS",
    categories: {
      "Backend & Runtimes": "Backend & Runtimes",
      "Realtime & Architecture": "Tiempo Real y Arquitectura",
      "Frontend & Mobile": "Frontend y Móvil",
      "Databases & ORMs": "Bases y ORMs"
    }
  },
  inspector: {
    badge: "INSPECTOR DE TECNOLOGÍA",
    header: "// TECNOLOGÍA SELECCIONADA",
    categoryLabel: "Categoría:",
    expLevelLabel: "NIVEL DE ACTUACIÓN:",
    practicalAppLabel: "APLICACIÓN PRÁCTICA:",
    techNoteHeader: "// NOTA TÉCNICA",
    techNoteText: "Integrado al ecosistema JavaScript/TypeScript de alto rendimiento para garantizar velocidad de desarrollo, tipado consistente y escala.",
    statusActive: "ESTADO: STACK ACTIVA"
  },
  projects: {
    badge: "// PROYECTOS Y ACTUACIÓN",
    title: "Proyectos Destacados",
    techFocusLabel: "ENFOQUE TÉCNICO:",
    items: {
      "01": {
        title: "Executive Jiu-Jitsu — Mobile App (iOS y Android)",
        category: "MOBILE ENGINEERING Y ARQUITECTURA NATIVA EXPO",
        description: "Ingeniería de aplicación móvil empresarial construida con Expo SDK 57 y React Native. Interfaz desarrollada con componentes nativos del sistema (Apple Liquid Glass y SF Symbols), arquitectura de navegación con Expo Router, retroalimentación háptica con expo-haptics, sincronización offline-first y pipeline automatizado de compilación multiplataforma mediante Expo EAS Build.",
        metrics: "Expo SDK 57 • Native UI (Liquid Glass) • EAS Build"
      },
      "02": {
        title: "Plataforma de Infraestructura WebRTC y SFU en Tiempo Real",
        category: "WEBRTC, LIVEKIT Y ALTA CONCURRENCIA",
        description: "Ingeniería de infraestructura para transmisión de audio, video y datos en tiempo real con alta concurrencia. Implementação de arquitectura WebRTC SFU utilizando LiveKit y WebSockets para garantizar comunicación de ultra baja latencia a escala.",
        metrics: "Ultra-Low Latency y WebRTC SFU Architecture"
      },
      "03": {
        title: "Arquitectura de Monorepos y APIs en Bun y Elysia.js",
        category: "HIGH-SPEED RUNTIMES Y ARQUITECTURA MONOREPO",
        description: "Construcción de ecosistema de microservicios y monorepos escalables utilizando Bun, Workspaces y Elysia.js con ORM Drizzle. Optimización de tiempos de compilación, bundling y respuestas HTTP sub-50ms.",
        metrics: "High-Speed Bundling y Latencia de API < 50ms"
      },
      "04": {
        title: "Sistemas Empresariales Enterprise en NestJS y Clean Arch",
        category: "ENTERPRISE NODE.JS, DDD Y CLEAN ARCHITECTURE",
        description: "Desarrollo y estructuración de arquitectura empresarial escalable en NestJS y Node.js. Aplicación estricta de Domain-Driven Design (DDD), Test-Driven Development (TDD) e integración con interfaces reactivas en React y Angular.",
        metrics: "Enterprise DDD, TDD y Esquemas 100% Type-Safe"
      }
    }
  },
  principles: {
    badge: "// PILARES TÉCNICOS",
    title: "Principios de Ingeniería",
    p1Code: "01 // TIEMPO REAL Y RENDIMIENTO",
    p1Title: "WebRTC y Runtimes Rápidos",
    p1Desc: "Aprovechamiento de WebRTC, WebSockets y runtimes como Bun y Node.js optimizados para garantizar comunicación en tiempo real y baja latencia.",
    p2Code: "02 // DOMAIN-DRIVEN DESIGN (DDD)",
    p2Title: "Modelado de Dominio y Clean Arch",
    p2Desc: "Desarrollo basado en Domain-Driven Design (DDD), aislando reglas de negocio en Bounded Contexts y Clean Architecture.",
    p3Code: "03 // TEST-DRIVEN DEVELOPMENT (TDD)",
    p3Title: "Calidad y Pruebas Automatizadas",
    p3Desc: "Desarrollo guiado por pruebas unitarias y de integración (TDD) con Bun Test y Jest para máxima cobertura y refactorizaciones seguras.",
    p4Code: "04 // CLEAN CODE Y BUENAS PRÁCTICAS",
    p4Title: "Código Limpio y Principios SOLID",
    p4Desc: "Escritura de código autodocumentado, cohesivo y legible, aplicando principios SOLID y patrones de diseño para mantenimiento continuo."
  },
  contact: {
    badge: "LUAN_LIMA // CONTACTO",
    headline: "Hablemos de nuevos proyectos u oportunidades.",
    subtitle: "Abierto a oportunidades en ingeniería de software, arquitectura de sistemas JavaScript/WebRTC y consultoría técnica.",
    copyBtnDefault: "COPIAR DIRECCIÓN DE CORREO",
    copyBtnSuccess: "CORREO COPIADO AL PORTAPAPELES",
    copyright: "© 2026 LUAN LIMA. TODOS LOS DERECHOS RESERVADOS."
  },
  stacks: {
    "bun-elysia": {
      category: "Backend & Runtimes",
      experience: "Alto Rendimiento y Alta Velocidad",
      highlight: "Runtime Ultrarrápido Bun, Servidor HTTP en Elysia.js, Bundling de Alta Velocidad y APIs con Muy Baja Latencia"
    },
    "node": {
      category: "Backend & Runtimes",
      experience: "Especialista Profesional",
      highlight: "Arquitectura Empresarial de Microservicios con NestJS y Node.js, Inyección de Dependencias (DI), Decoradores, Módulos, Express/Fastify y APIs RESTful Resilientes."
    },
    "ts-js": {
      category: "Backend & Runtimes",
      experience: "Base del Ecosistema",
      highlight: "Tipado Estricto, Contratos Rígidos, Asincronismo Avanzado y Event Loop en JavaScript (ES6+) y TypeScript"
    },
    "webrtc-ws": {
      category: "Realtime & Architecture",
      experience: "Especialidad en Tiempo Real",
      highlight: "Arquitectura WebRTC SFU con LiveKit, transmisiones P2P, DataChannels, streaming de audio/video y WebSockets de alta concurrencia."
    },
    "api": {
      category: "Realtime & Architecture",
      experience: "Arquitectura de Sistemas",
      highlight: "APIs RESTful de alta resiliencia, Arquitectura Orientada a Eventos, WebSockets, Server-Sent Events (SSE) y contratos unificados."
    },
    "clean-tdd-ddd": {
      category: "Realtime & Architecture",
      experience: "Prácticas de Ingeniería",
      highlight: "Domain-Driven Design (DDD), Test-Driven Development (TDD), Clean Architecture, Principios SOLID y Pruebas Automatizadas"
    },
    "react-vue": {
      category: "Frontend & Mobile",
      experience: "Experiencia Profesional",
      highlight: "Aplicaciones Web Escalables en React.js y Vue.js, Componentización Modular, Hooks y Reactividad Avanzada"
    },
    "angular": {
      category: "Frontend & Mobile",
      experience: "Arquitectura Enterprise",
      highlight: "Desarrollo Web Reactivo en Angular, SPAs Empresariales, Inyección de Dependencias y RxJS"
    },
    "rn-expo": {
      category: "Frontend & Mobile",
      experience: "Desarrollo Móvil",
      highlight: "Aplicaciones Multiplataforma en React Native y Expo, EAS Builds e Integración con Ecosistema JS"
    },
    "styling": {
      category: "Frontend & Mobile",
      experience: "UI y Design Systems",
      highlight: "Tailwind CSS, Styled Components, Design Tokens, Interfaces Responsivas Cyber-Minimalistas y Animaciones"
    },
    "mysql-postgres": {
      category: "Databases & ORMs",
      experience: "Experiencia Profesional",
      highlight: "Bases Relacionales MySQL y PostgreSQL, Optimización de Consultas, Índices y Modelado Estricto de Datos"
    },
    "drizzle-prisma": {
      category: "Databases & ORMs",
      experience: "Experiencia Profesional",
      highlight: "Consultas SQL Type-safe, Migraciones de Bases de Datos, Drizzle ORM, Prisma y Modelado Relacional"
    }
  }
};
